function onVisible(element, callback, options = {}) {
  const defaultOptions = {
    threshold: 0.1,
    rootMargin: '0px',
    once: false
  };

  const config = { ...defaultOptions, ...options };

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        callback(entry.target, entry);

        if (config.once) {
          observer.unobserve(entry.target);
        }
      }
    });
  }, config);

  if (element) {
    observer.observe(element);
  }

  return observer;
}

document.addEventListener('turbolinks:load', function() {
  const popularTopicsSection = document.querySelector('.js-popular-topics');
  const banner1 = document.querySelector('.js-banner-v1');
  const banner2 = document.querySelector('.js-banner-v2');

  if (popularTopicsSection && !banner1 && !banner2) {
    onVisible(popularTopicsSection, element => {
      Sofatutor.tracking.convert.trigger('100245332');
      $.cookie('global_footer_banner_seen', true, {
        expires: 30, // 30 days
        path: '/',
        secure: window.location.protocol === 'https:',
        sameSite: 'Lax'
      });
    });
  }

  if (banner1) {
    onVisible(banner1, element => {
      Sofatutor.tracking.convert.trigger('100245332');
      $.cookie('global_footer_banner_seen', true, {
        expires: 30, // 30 days
        path: '/',
        secure: window.location.protocol === 'https:',
        sameSite: 'Lax'
      });
    });
  }

  if (banner2) {
    onVisible(banner2, element => {
      Sofatutor.tracking.convert.trigger('100245332');
      $.cookie('global_footer_banner_seen', true, {
        expires: 30, // 30 days
        path: '/',
        secure: window.location.protocol === 'https:',
        sameSite: 'Lax'
      });
    });
  }
});
